import { Nullable } from '@dxb-web-ui-framework/common/types';
import { Device } from '../../domain/Device/entities';

const defaultDeviceManagementState = {
  devicesData: null,
  selectedDevice: null,
  setSelectedDevice: (device: Nullable<Device>) => {},
  onResetSelectedDevice: () => {},
  getDevicesData: () => {},
  loadingState: {
    isLoadingDevicesData: false,
  },
  errorState: {
    devicesDataError: undefined,
  },
  // pagination
  currentPage: 1,
  paginationSettings: {
    pageSize: 10,
    pageOffset: 0,
  },
  paginationResult: {
    totalResults: 0,
    totalPages: 1,
  },
  onPageChange: () => {},
};

export { defaultDeviceManagementState };
